import { createContext } from 'react';

export const AppContext = createContext({
    localeId: 'en-US',
    locale: 'English',
    languageId: 'en',
    onLanguageChange: (e:any) => {e},
    changeTheme: (e:any) => {},
    // avatar: null
});

AppContext.displayName = 'AppContext';